exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".logo-lg img {\r\n    height: 50px;\r\n    padding: 0.6em 0;\r\n    display: block;\r\n    margin: auto;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/www/kh_indesso_web/src/app/components/main-header/main-header.component.css
// module id = ../../../../../src/app/components/main-header/main-header.component.css
// module chunks = 0